export enum PotentialSavingsCloseActions {
	Apply = 'apply',
	Refresh = 'refresh',
	Error = 'error',
}
